const TimeHelper = {
  nowInSeconds() {
    return Math.floor(Date.now() / 1e3);
  }
};
export default TimeHelper;
